import { Component } from "react";
import View from "./view";
import { withRouter } from "react-router-dom";

import "./index.css";

class Page extends Component {
  constructor(props) {
    super(props);

    let fullscreen = false;
    if (["/login"].includes(this.props.location.pathname)) {
      fullscreen = true;
    }

    this.state = {
      header: props.header || props.location.pathname,
      fullscreen
    };

    this._navigate = this._navigate.bind(this);
    this._back = this._back.bind(this);
  }

  async componentDidMount() {}

  async componentDidUpdate(prevProps, prevState) {}

  render() {
    return View.call(this);
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }

  _back() {
    const { history } = this.props;
    history.goBack();
  }
}

export default withRouter(Page);



// WEBPACK FOOTER //
// ./src/components/page/index.js